<button
  matButton="outlined"
  class="tw-w-full tw-whitespace-nowrap"
  (click)="openNewFolderModal()"
>
  <mat-icon svgIcon="add-folder-2" aria-hidden="true" />
  New Folder
</button>
